// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';

const requiredPart = t.interface({
  tag: t.literal('CONTAINS_STRING'),
  field: t.string,
  value: t.string,
});

export const ContainsStringFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface ContainsStringFilter extends t.TypeOf<typeof ContainsStringFilterSchema> {}
